import { ThunkDispatch } from "@reduxjs/toolkit";
import { LOGIN } from "codes";
import { clearAuthSession } from "./enhancedClearStorage";
import history from "./history";

export default async function logout(dispatch: ThunkDispatch<any, any, any>) {
  clearAuthSession(dispatch);
  history.push(LOGIN);
}
